export const allSubProducts = [
  "accessories",
  "actuators",
  "adapters",
  "bufferVessels",
  "sensors",
  "measuringValves",
  "spareParts",
] as const;

export type SubProduct = (typeof allSubProducts)[number];

export function isSubProduct(value: string): value is SubProduct {
  return allSubProducts.includes(value as SubProduct);
}

export const subProductTypeToProductType = (subProductType: SubProduct) => {
  return (
    {
      accessories: "accessory",
      actuators: "actuator",
      adapters: "adapter",
      bufferVessels: "bufferVessel",
      measuringValves: "measuringValve",
      sensors: "sensor",
      spareParts: "sparePart",
    } as const
  )[subProductType];
};

export const productTypeToSubProductType = (productType: string) => {
  return ({
    accessory: "accessories",
    actuator: "actuators",
    adapter: "adapters",
    bufferVessel: "bufferVessels",
    measuringValve: "measuringValves",
    sensor: "sensors",
    sparePart: "spareParts",
  }[productType] ?? productType) as SubProduct;
};
